<script>
import ChartStyle from './ChartStyle'

import arrowSVG from './arrow.svg'
import ECharts from '../../../components/Charts/ECharts'

const Y_AXIS_SPLIT_NUMBER = 5
const Y_AXIS_INTERVAL = 65

const WIND_SPEED_ID = '1012'
const WIND_DIRECT_ID = '1013'
const WIND_SPEED_COLOR = '#F99F52'

export default {
  name: 'TrendChart',
  extends: ECharts,
  props: {
    isWeatherInstrument: {
      type: Boolean
    },
    factors: {
      required: true,
      type: Array
    },
    dataTimes: {
      required: true,
      type: Array
    },
    data: {
      required: true,
      type: Array
    }
  },
  computed: {
    factorMap () {
      return this.factors.reduce((map, factor) => {
        map[factor.id] = factor
        return map
      }, {})
    },
    chartOpt () {
      let {factors, dataTimes, data, factorMap} = this
      this.setIsWeatherFlag(false)

      if (this.isWeatherInstrument) {
        let windDirectFactor = factorMap[WIND_DIRECT_ID]

        if (windDirectFactor) {
          let windSpeedFactor = factorMap[WIND_SPEED_ID]

          if (windSpeedFactor) {
            windSpeedFactor.color = WIND_SPEED_COLOR
            factors = factors.filter(factor => factor.id !== WIND_DIRECT_ID)

            data = data.map(data => {
              let windSpeedData = data[WIND_SPEED_ID]

              if (!windSpeedData || !Number.isFinite(windSpeedData.value)) {
                return data
              }

              let windDirectData = data[WIND_DIRECT_ID]

              if (!windDirectData) {
                return data
              }

              let windDirectValue = windDirectData.value

              if (!Number.isFinite(windDirectValue)) {
                return data
              }

              return Object.assign({}, data, {
                [WIND_SPEED_ID]: Object.assign({}, data[WIND_SPEED_ID], {
                  symbol: `image://${arrowSVG}`,
                  symbolSize: 20,
                  symbolRotate: 180 - windDirectValue,
                  windDirectValue,
                  windDirectFlag: windDirectData.flag
                })
              })
            })

            this.setIsWeatherFlag(true)
          }
        }
      }

      let units = [...new Set(factors.map(factor => factor.displayUnit))]
      let unitValueMap = units.reduce((map, unit) => {
        map[unit] = {
          min: 2147483647,
          max: -2147483648
        }

        return map
      }, {})

      let dataLen = data.length

      factors.forEach(factor => {
        let factorId = factor.id
        let minMax = unitValueMap[factor.displayUnit]

        for (let i = 0; i < dataLen; i++) {
          let value = data[i][factorId].value

          if (Number.isFinite(value)) {
            if (value < minMax.min) {
              minMax.min = value
            } else if (value > minMax.max) {
              minMax.max = value
            }
          }
        }
      })

      let gridRight = Y_AXIS_INTERVAL
      let unitIndexMap = {}
      let yAxis = units.map((unit, index) => {
        let {min, max} = unitValueMap[unit]
        min = Math.floor(min)
        max = Math.ceil(max)

        if (min === max) {
          min -= 1
          max += 1
        }
        // let interval = (max - min) / Y_AXIS_SPLIT_NUMBER
        let offset = 0

        if (index > 1) {
          offset = (index - 1) * Y_AXIS_INTERVAL
          gridRight += Y_AXIS_INTERVAL
        }

        unitIndexMap[unit] = index

        return {
          type: 'value',
          name: unit,
          min,
          max,
          splitNumber: Y_AXIS_SPLIT_NUMBER,
          // interval: Number(interval.toFixed(interval >= 1 ? 1 : 3)),
          position: index === 0 ? 'left' : 'right',
          offset,
          axisLine: {
            show: true
          },
          splitLine: {
            show: index === 0
          },
          axisTick: {
            show: true
          },
          axisLabel: {
            fontFamily: ChartStyle.NUMBER_FONT_FAMILY
          }
        }
      })

      let series = factors.map(({id, displayUnit, color}) => ({
        id,
        name: id,
        type: 'line',
        data: data.map(data => data[id]),
        showSymbol: id === WIND_SPEED_ID,
        yAxisIndex: unitIndexMap[displayUnit],
        color
      }))

      return {
        tooltip: {
          trigger: 'axis',
          appendToBody: true,
          axisPointer: {
            type: 'cross',
            animation: false
          },
          formatter: this.tooltipFormatter
        },
        legend: {
          show: true,
          bottom: 7,
          left: 'center',
          width: '90%',
          type: 'scroll',
          formatter: this.legendFormatter
        },
        grid: {
          top: 45,
          right: gridRight,
          bottom: 100,
          left: Y_AXIS_INTERVAL,
          containLabel: false
        },
        xAxis: {
          type: 'category',
          data: dataTimes,
          axisTick: {
            alignWithLabel: true
          },
          axisLabel: {
            fontFamily: ChartStyle.NUMBER_FONT_FAMILY
          }
        },
        yAxis,
        dataZoom: [{
          type: 'inside',
          xAxisIndex: 0,
          minSpan: 5
        }, {
          type: 'slider',
          realtime: true,
          xAxisIndex: 0,
          minSpan: 5,
          // height: 23,
          bottom: 41,
          left: Y_AXIS_INTERVAL,
          right: gridRight,
          // handleIcon: 'M10.7,11.9H9.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4h1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7V23h6.6V24.4z M13.3,19.6H6.7v-1.4h6.6V19.6z',
          handleSize: '70%',
          handleStyle: {
            color: '#fff',
            shadowBlur: 4,
            shadowColor: 'rgba(0, 0, 0, 0.15)',
            shadowOffsetX: 2,
            shadowOffsetY: 2
          },
          // dataBackground: {
          //   areaStyle: '#E4F0FF'
          // }
          fillerColor: 'rgba(228, 240, 255, .6)',
          borderColor: '#E4F0FF'
        }],
        series
      }
    }
  },
  methods: {
    afterInit () {
      this.ready = true
      this.render()
    },
    render () {
      this.resize()
      this.setOpt(this.chartOpt)
    },
    setIsWeatherFlag (flag) {
      this.isWeatherFlag = flag
    },
    getToolTipHTML (marker, seriesId, value, flag) {
      let {factorMap} = this

      return [
        `<div style="margin: 10px 0 0;line-height:1;">`,
        `<div style="margin: 0px 0 0;line-height:1;">`,
        `<div style="margin: 0px 0 0;line-height:1;">`,
        marker,
        `<span style="font-size:14px;color:#666;font-weight:400;margin-left:2px">${factorMap[seriesId].name}</span>`,
        `<span style="float:right;margin-left:20px;font-size:14px;color:#666;font-weight:900">${Number.isFinite(value) ? `${value}` : '--'} ${(factorMap[seriesId] || {}).displayUnit || ''} ${flag ? `(${flag})` : ''}</span>`,
        `<div style="clear:both"></div>`,
        `</div>`,
        `<div style="clear:both"></div>`,
        `</div>`,
        `<div style="clear:both"></div>`,
        `</div>`
      ]
    },
    tooltipFormatter (params) {
      let {factorMap} = this

      return [
        `<div style="font-size:14px;color:#666;font-weight:400;line-height:1;">${params[0].axisValue}</div>`,
        params.map(({marker, seriesId, data}) => {
          let htmls = this.getToolTipHTML(marker, seriesId, data.value, data.flag)

          if (seriesId === WIND_SPEED_ID) {
            let windDirectFactor = factorMap[WIND_DIRECT_ID]

            if (windDirectFactor) {
              htmls.push(...this.getToolTipHTML(marker, WIND_DIRECT_ID, data.windDirectValue, data.windDirectFlag))
            }
          }

          return htmls.join('')
        }).join('')
      ].join('')
    },
    legendFormatter (id) {
      let factor = this.factorMap[id]
      return this.isWeatherFlag && id === WIND_SPEED_ID ? '风速风向' : factor.name
    }
  },
  watch: {
    data (data) {
      if (this.ready) {
        this.render()
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/07Env/02History/TrendChart.vue